import { render, staticRenderFns } from "./TaskDefinitionsOverview.vue?vue&type=template&id=0faf10fe&scoped=true"
import script from "./TaskDefinitionsOverview.vue?vue&type=script&lang=js"
export * from "./TaskDefinitionsOverview.vue?vue&type=script&lang=js"
import style0 from "./TaskDefinitionsOverview.vue?vue&type=style&index=0&id=0faf10fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf10fe",
  null
  
)

export default component.exports